import {
  URL_GET_ALL_KITCHENS,
  URL_GET_ALL_ORDERS,
  URL_GET_ALL_REGIONS,
  URL_GET_ALL_SETTINGS,
  URL_GET_ALL_USERS,
  URL_GET_INBOX_DATA,
  URL_KITCHEN_ACTIVE,
  URL_KITCHEN_APPROVE,
  URL_KITCHEN_REJECT,
  URL_KITCHEN_SUSPEND,
  URL_LOGIN,
  URL_POST_CREATE_BULK_CHAT,
  URL_POST_CREATE_CHAT,
  URL_POST_UPDATE_AGENT_INFO,
  URL_POST_UPDATE_FAQS,
  URL_POST_UPDATE_FEES,
  URL_POST_UPDATE_KITCHEN_INFO,
  URL_POST_UPDATE_META,
  URL_POST_UPDATE_USER_INFO,
  URL_POST_SEND_NOTIFICATION,
  URL_POST_UPDATE_HOLIDAYS,
  URL_GET_DELETE_CHAT,
  URL_GET_COMISSIONS,
  URL_GET_WALLETS,
  URL_CREATE_STAFF_ACCOUNT,
  URL_GET_DELETE_STAFF_ACCOUNT,
  URL_PAY_TO_VENDOR,
  URL_GET_CHANGE_PASSWORD_STAFF,
  URL_GET_ALL_VENDORS_GIFT,
  URL_POST_CREATE_GIFT,
  URL_POST_UPDATE_GIFT,
  URL_DELETE_GIFT
} from "./API_LINKS";
import { clearStorage, getToken } from "./models/GlobalAdmin";

/* eslint-disable @typescript-eslint/no-unused-vars */
const MakePostCall = (url, requestBody, callback) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + getToken());


  var raw = JSON.stringify(requestBody);

  fetch(url, {
    
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  })
    .then((response) => response.json())
    .then((result) => {return callback(null, result)})
    .catch((error) => callback(error, null));
};

const MakePostCallFormData = (url, requestBody, callback) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + getToken()); // Keep Authorization header
  // Don't set "Content-Type" because `FormData` will handle it automatically.

  var formData = new FormData();

  // Append all fields to FormData
  for (const key in requestBody) {
    formData.append(key, requestBody[key]);
  }

  fetch(url, {
    method: "POST",
    headers: myHeaders, // No need to set 'Content-Type'
    body: formData,
    redirect: "follow",
  })
    .then((response) => response.json())
    .then((result) => callback(null, result))
    .catch((error) => callback(error, null));
};


const MakeGetWithAuthCall = (url, token, callback) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + token);

  fetch(url, {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  })
    .then((response) => {
        if(response.status===401){
            console.log('status',response.status)
            clearStorage();
            // document.location.reload();
            return;
        }else{
          
            return response.json();
        }
     
    })
    .then((result) => callback(null, result))
    .catch((error) => callback(error, null));
};

export function login(data, onComplete) {

  MakePostCall(URL_LOGIN, data, onComplete);
}




export function sendBulkMessage(type,message,onComplete){
  MakePostCall(URL_POST_CREATE_BULK_CHAT,{type:type,message:message},onComplete);
}




export function loadAllUsers(onComplete) {
  MakeGetWithAuthCall(URL_GET_ALL_USERS+"?type=user", getToken(), onComplete);
}
export function loadAllGiftVendors(onComplete) {
  MakeGetWithAuthCall(URL_GET_ALL_VENDORS_GIFT, getToken(), onComplete);
}




export function loadAllStaff(onComplete) {
  MakeGetWithAuthCall(URL_GET_ALL_USERS, getToken(), onComplete);
}
export function loadAllAgents(onComplete) {
  MakeGetWithAuthCall(URL_GET_ALL_USERS+"?type=agent", getToken(), onComplete);
}


export function loadRegionsJSONArray(onComplete) {
  MakeGetWithAuthCall(URL_GET_ALL_REGIONS, getToken(), onComplete);
}

export function loadAllKitchens(onComplete) {
  MakeGetWithAuthCall(URL_GET_ALL_KITCHENS, getToken(), onComplete);
}
export function loadComissions(onComplete) {
  MakeGetWithAuthCall(URL_GET_COMISSIONS, getToken(), onComplete);
}
export function loadWallets(onComplete) {
  MakeGetWithAuthCall(URL_GET_WALLETS, getToken(), onComplete);
}
export function sendReplyToInbox(data,onComplete){
  // console.log('called');
  MakePostCall(URL_POST_CREATE_CHAT,data,onComplete);
  
}


export function createNewGift(data,onComplete){
  // console.log('called');
  MakePostCallFormData(URL_POST_CREATE_GIFT,data,onComplete);
  
}


export function updateGift(id,data,onComplete){
  // console.log('called');
  MakePostCallFormData(URL_POST_UPDATE_GIFT+"/"+id,data,onComplete);
  
}



export function deleteGift(id,onComplete){
  // console.log('called');
  MakeGetWithAuthCall(URL_DELETE_GIFT+"/"+id, getToken(), onComplete);


}




export function deleteChatWithId(id,onComplete){
  MakeGetWithAuthCall(URL_GET_DELETE_CHAT+id,getToken(),onComplete);
}
export function deleteMemberWithId(id,onComplete){
  MakeGetWithAuthCall(URL_GET_DELETE_STAFF_ACCOUNT+id,getToken(),onComplete);
}
export function changeMemberPasswordWithId(id,password,onComplete){
  MakeGetWithAuthCall(URL_GET_CHANGE_PASSWORD_STAFF+id+"?password="+password,getToken(),onComplete);
}

export function loadAllOrders(onComplete){
  MakeGetWithAuthCall(URL_GET_ALL_ORDERS,getToken(),onComplete);
}
export function loadAllInboxData(onComplete){
  MakeGetWithAuthCall(URL_GET_INBOX_DATA,getToken(),onComplete)
}
export function loadAllSettings(onComplete){
  MakeGetWithAuthCall(URL_GET_ALL_SETTINGS,getToken(),onComplete)
}
export function approveKitchen(kitchen_id,message,onComplete){
  MakePostCall(URL_KITCHEN_APPROVE,{
    id:kitchen_id
  },onComplete);
}
export function payVendor(data,onComplete){
  MakePostCall(URL_PAY_TO_VENDOR,data,onComplete);
}
export function rejectKitchen(kitchen_id,message,onComplete){
  MakePostCall(URL_KITCHEN_REJECT,{
    id:kitchen_id,message:message
  },onComplete);
}
export function updateHolidays(data,onComplete){
  MakePostCall(URL_POST_UPDATE_HOLIDAYS,{
    holidays:data
  },onComplete);
}
export function createMemberAccount(data,onComplete){
  MakePostCall(URL_CREATE_STAFF_ACCOUNT,data,onComplete);
}
export function activeKitchen(kitchen_id,message,onComplete){
  MakePostCall(URL_KITCHEN_ACTIVE,{
    id:kitchen_id,message:message
  },onComplete);
}
export function suspendKitchen(kitchen_id,message,onComplete){
  MakePostCall(URL_KITCHEN_SUSPEND,{
    id:kitchen_id,message:message
  },onComplete);
}

export function updateMetaData(data,onComplete){
  MakePostCall(URL_POST_UPDATE_META,data,onComplete);
}

export function sendPushNotification(data,onComplete){
  MakePostCall(URL_POST_SEND_NOTIFICATION,data,onComplete);
}

export function updateFees(data,onComplete){
  MakePostCall(URL_POST_UPDATE_FEES,data,onComplete);
}

export function updateKitchenInfo(data,onComplete){
  MakePostCall(URL_POST_UPDATE_KITCHEN_INFO,data,onComplete);
}

export function updateUserInfo(data,onComplete){
  MakePostCall(URL_POST_UPDATE_USER_INFO,data,onComplete);
}
export function updateAgentInfo(data,onComplete){
  MakePostCall(URL_POST_UPDATE_AGENT_INFO,data,onComplete);
}
export function updateFaqsInfo(data,onComplete){
  MakePostCall(URL_POST_UPDATE_FAQS,data,onComplete);
}